/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $GdmDisapprovalRequest = {
  properties: {
    professionalId: {
      type: 'string',
      isRequired: true,
    },
    userId: {
      type: 'string',
      isRequired: true,
    },
    reason: {
      type: 'string',
      isRequired: true,
    },
    allowRegister: {
      type: 'string',
    },
    document: {
      type: 'File',
    },
  },
} as const;
